import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import netflix from "../../Assets/Projects/netflix.webp";
import nw from "../../Assets/Projects/nw.webp";
import shop from "../../Assets/Projects/shop.webp";
import chatify from "../../Assets/Projects/chatify.webp";
import yt from "../../Assets/Projects/yt.webp";
import vv from "../../Assets/Projects/vv.webp";
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Work </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={5} lg={4} className="project-card">
            <ProjectCard
              imgPath={vv}
              isBlog={false}
              title="Vital Vault"
              description="Vital Vault, where healthcare data management meets innovation. Vital Vault is more than just a healthcare data system; it's a solution designed to streamline the complexities of healthcare data, making it secure, accessible, and efficient."
              ghLink="https://github.com/007aneesh/api_avengers"
              demoLink="https://api-avengers-frontend.vercel.app/"
            />
          </Col>
          <Col md={5} lg={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chatify"
              description="Chatify is a Firebase maintained real time chat Application that allows users to chat and send images securely."
              ghLink="https://github.com/007aneesh/chatify"
              demoLink="https://chatify-beta.vercel.app/"
            />
          </Col>

          <Col md={5} lg={4} className="project-card">
            <ProjectCard
              imgPath={shop}
              isBlog={false}
              title="Shop Box"
              description="A react js shopping website which fetches the product data from the Fake Store API."
              ghLink="https://github.com/007aneesh/shop-box"
              demoLink="https://007aneesh.github.io/shop-box/"
            />
          </Col>

          <Col md={5} lg={4} className="project-card">
            <ProjectCard
              imgPath={yt}
              isBlog={false}
              title="YouTube Clone"
              description="A react Js and MUI based YouTube Clone which fetched videos or other data from YouTube API."
              ghLink="https://github.com/007aneesh/youtube-clone"
            />
          </Col>

          <Col md={5} lg={4} className="project-card">
            <ProjectCard
              imgPath={nw}
              isBlog={false}
              title="News Website"
              description="A react js website that provides the latest news feed via the news api."
              ghLink="https://github.com/007aneesh/newsAPI"
            />
          </Col>

          <Col md={5} lg={4} className="project-card">
            <ProjectCard
              imgPath={netflix}
              isBlog={false}
              title="Netflix Clone"
              description="Netflix clone designed via HTML, CSS and JS."
              ghLink="https://github.com/007aneesh/Netflix-clone-By-Aneesh"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
